module.exports = __webpack_public_path__ + "static/media/24092018.5bfe99e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/24092018.png
// module id = 245
// module chunks = 0